<template>
  <div class="color-sample-rim">
    <div class="color-sample m2">
      <section class="spacer" />
      <section>
        <p class="extra-small-text">
          平歳三年十二月三十一日没
        </p>
      </section>
      <section class="flex center grow adjust-bottom-2">
        <div class="box bottom">
          <p class="small-text">
            <small>俗名</small>
            源頼朝
            <small>享年 八十八歳</small>
          </p>
        </div>
      </section>
      <section class="flex center grow column">
        <section class="flex center grow adjust-top">
          <div class="box top">
            <p class="box default-text adjust">
              武皇嘯厚大禅門
            </p>
          </div>
        </section>
        <section class="flex center grow adjust-top">
          <div class="box top">
            <p class="box default-text adjust">
              武皇嘯厚大禅門
            </p>
          </div>
        </section>
      </section>
      <section class="flex center grow adjust-bottom-2">
        <div class="box bottom">
          <p class="small-text">
            <small>俗名</small>
            源頼朝
            <small>享年 八十八歳</small>
          </p>
        </div>
      </section>
      <section>
        <p class="extra-small-text">
          平歳三年十二月三十一日没
        </p>
      </section>
      <section class="spacer" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";
</style>
